import { Component, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { InputSelectButton } from '../../../../../../shared/components/input-select-button/input-select-button';
import { ReportExportFormat } from '../../../../../../types/enums/report.enum';
import { InputSelectButtonInterface } from '../../../../../../types/interfaces/input.interface';

@Component({
  selector: 'app-report-format',
  imports: [
    InputSelectButton,
  ],
  templateUrl: './report-format.html',
  styleUrl: './report-format.css',
})
export class ReportFormatStep {
  @Input({required: true}) formGroup!: FormGroup;

  public get currentFormatConfig(): InputSelectButtonInterface {
    return {
      formGroup: this.formGroup,
      isTranslated: true,
      label: 'common.input.report-format.label',
      id: 'format',
      iconLeft: 'file_save',
      options: [
        {
          label: 'PDF',
          value: ReportExportFormat.PDF,
        },
        {
          label: 'CSV',
          value: ReportExportFormat.CSV,
        },
      ],
    };
  }
}
